import StorageHelper from '@/utils/storageHelper'
import { httpPost } from '@/utils/service'
import { getGlobalConfig } from '@/utils/globalConfig'

export async function generateAccessToken () {
  try {
    const response = await httpPost('GENERATE_ACCESS_TOKEN', {
      data: {},
      config: {
        headers: {
          'x-api-key': getGlobalConfig('API_KEY')
        }
      }
    })
    if (response && response.data) {
      StorageHelper.setItem('tka', response.data.accessToken)
      return response.data.accessToken
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data
    }
    throw error
  }
}
